import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../../common/html/checkbox'
import { Icon } from '../../../../../common/html/icon'
import { InputSearchDropdown } from '../../../../../library/common/html/input/InputSearchDropdown'
import { ItemHover } from '../../../common/html/ItemHover'
import { handleArrCheck } from '../../helper'
import { changeDataCellTable } from '../../store/slice'
import { Level } from './Level'

export const LevelSelect = ({
  data,
  rangeScore,
  rowId,
  colId,
  itemAnyByScore,
}) => {
  const dispatch = useDispatch()

  const arr = useMemo(() => data.split(',').map(Number), [data])
  const rangeScoreFormat = useMemo(
    () => [...rangeScore, itemAnyByScore],
    [rangeScore.length, data],
  )

  const handleChoose = (item) => {
    if (item.scoreRangeId === itemAnyByScore.scoreRangeId) {
      dispatch(
        changeDataCellTable({
          rowId,
          colId,
          data: '0',
        }),
      )
    } else {
      dispatch(
        changeDataCellTable({
          rowId,
          colId,
          data: handleArrCheck(arr, item?.scoreRangeId),
        }),
      )
    }
  }

  const actionAfterHiddenDrop = () => {
    if (!arr.length) {
      dispatch(
        changeDataCellTable({
          rowId,
          colId,
          data: '0',
        }),
      )
    }
  }

  const renderElement = () => {
    return (
      <div className="dFlex alignItemsCenter">
        <div className="flex1">
          <Level data={data} dataRange={rangeScoreFormat} />
        </div>
        <Icon className="icon-caret-bottom" style={{ fontSize: 8 }} />
      </div>
    )
  }

  const renderDropdown = () => {
    return (
      <>
        {rangeScoreFormat?.map((item, index) => (
          <ItemHover key={index}>
            <DropdownItem
              item={item}
              handleChoose={handleChoose}
              check={arr.includes(item?.scoreRangeId)}
            />
          </ItemHover>
        ))}
      </>
    )
  }

  return (
    <div>
      <InputSearchDropdown
        style={{ width: '100%', padding: '1px 0' }}
        renderElement={renderElement}
        renderDropdown={renderDropdown}
        actionAfterHiddenDrop={actionAfterHiddenDrop}
      />
    </div>
  )
}

export const DropdownItem = ({ item, handleChoose, check }) => {
  return (
    <Checkbox
      appendStyle={{
        padding: '8px 10px',
        borderBottom: '1px solid #E5E5E5',
      }}
      title={
        item?.isI18n ? <Translate value={item.label} /> : item?.scoreRangeName
      }
      isCheckOnClickText
      styleIcon={{ fontSize: 15, color: item?.color || '#BCBCBC' }}
      style={{ width: '100%' }}
      onChange={() => handleChoose(item)}
      checked={check}
    />
  )
}
